import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICorrelationSpectrum } from '@app/api/interfaces/chart-data/correlation-spectrum';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export interface IFpCorrelationSpectrumState {
  currentTab: FpCorrelationTabs.CorrelationSpectrum;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
  data: ICorrelationSpectrum[] | null;
  loading: boolean;
  isChartFullscreenActive: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpCorrelationSpectrumState: IFpCorrelationSpectrumState = {
  currentTab: FpCorrelationTabs.CorrelationSpectrum,
  date: null,
  popupMainData: null,
  data: null,
  loading: false,
  isChartFullscreenActive: false,
  error: null,
};
